/**
 * @file Shared React component — components/Layout/SidebarExpert.tsx.
 */

import React, { useEffect, useState } from "react";
import "./Sidebar.css";
import axiosClient from "../../api/axiosClient";
import SidebarFooter from "./SidebarFooter";

interface Props {
  activeSection?: string;
  onSelect: (section: string) => void;
}

const SidebarExpert: React.FC<Props> = ({ activeSection = "Home", onSelect }) => {
  const [myMaterialName, setMyMaterialName] = useState<string | null>(null);

  useEffect(() => {
    // fetch expert profile to show assigned material (optional)
    axiosClient
      .get("/expert/profile")
      .then((res) => {
        if (res.data?.success && res.data?.data?.material) {
          setMyMaterialName(res.data.data.material.name || null);
        }
      })
      .catch(() => {
        setMyMaterialName(null);
      });
  }, []);

  const handleClick = (section: string) => {
    onSelect(section);
  };

  return (
    <aside className="sidebar">
      <div className="sidebar-inner">
        <button
          className={`menu-btn ${activeSection === "Home" ? "active" : ""}`}
          onClick={() => handleClick("Home")}
        >
          Home
        </button>

        <button
          className={`menu-btn ${activeSection === "Profile" ? "active" : ""}`}
          onClick={() => handleClick("Profile")}
        >
          Profile
        </button>

        <button
          className={`menu-btn ${activeSection === "My Materials" ? "active" : ""}`}
          onClick={() => handleClick("My Materials")}
        >
          My Materials
        </button>

        <button
          className={`menu-btn ${
            activeSection === "Review Submissions" ? "active" : ""
          }`}
          onClick={() => handleClick("Review Submissions")}
        >
          Review Submissions
        </button>

        <button
          className={`menu-btn ${activeSection === "All Datasets" ? "active" : ""}`}
          onClick={() => handleClick("All Datasets")}
        >
          All Datasets
        </button>

        {/* show assigned material (if any) */}
        {/* <div style={{ width: "100%", padding: "0.6rem 1rem" }}>
          <small style={{ color: "#333" }}>Assigned Material</small>
          <div
            style={{
              marginTop: 8,
              padding: "0.4rem 0.6rem",
              background: "#f5f5f5",
              borderRadius: 6,
              textAlign: "center",
              fontWeight: 600,
            }}
          >
            {myMaterialName ?? "Not assigned"}
          </div>
        </div> */}

        <div className="progress-line" style={{ marginTop: 12 }}></div>
      </div>

      <SidebarFooter />
    </aside>
  );
};

/** React component — Sidebar Expert. */
export default SidebarExpert;